import { AxiosResponse } from 'axios';
import { axiosCoreInstance } from '../../AxiosCoreInterceptor';
import { IndividualJustificationDto } from '../../../Model/Dto/EmploymentEquity/IndividualJustification';
import * as ApiUrls from './ApiUrl.IndividualJustification';

export const IndividualJustificationService = {
    Get: (scorecardId: string, id: number): Promise<AxiosResponse<IndividualJustificationDto.DtoOut>> =>
        axiosCoreInstance.get(ApiUrls.GetIndividualJustification(scorecardId, id)),

    Create: (model: IndividualJustificationDto.DtoIn): Promise<AxiosResponse<IndividualJustificationDto.DtoOut>> =>
        axiosCoreInstance.post(ApiUrls.CreateIndividualJustification, model),

    Update: (model: IndividualJustificationDto.DtoIn): Promise<AxiosResponse<IndividualJustificationDto.DtoOut>> =>
        axiosCoreInstance.put(ApiUrls.UpdateIndividualJustification, model),

    Delete: (scorecardId: string, id: number): Promise<AxiosResponse<void>> =>
        axiosCoreInstance.delete(ApiUrls.DeleteIndividualJustification(scorecardId, id)),
};
